var fudgeInputs = document.querySelectorAll('.fudge-selector');

for (var i = 0; i < fudgeInputs.length; i++) {
    var input = fudgeInputs[i];
    var fudgeNumber = input.dataset.attribute;
    
    fudgeInputs[i].addEventListener('change', function(e, v) {
      // console.log('eeee', e, v)
      console.log('value is', e.target.options[e.target.selectedIndex].value, 'fudge attribute is', e.target.dataset.attribute);

      addOrUpdateFudgeProperty(e.target.dataset.attribute, e.target.options[e.target.selectedIndex].value)
    });

    var selectedIndex = input.selectedIndex ?? 0;
    console.log('ddd', fudgeNumber, selectedIndex, input.options[selectedIndex].value)
    addOrUpdateFudgeProperty(fudgeNumber, input.options[selectedIndex].value)
}


function addOrUpdateFudgeProperty(fudgeNumber, fudgeValue) {
  var formClass = '[data-type="add-to-cart-form"]';
  var inputSelector = 'input[name="properties[Fudge ' + fudgeNumber + ']"]';
  
  var findFudgeField = document.querySelector(formClass + ' ' + inputSelector);
  if (findFudgeField == null) {
    var input = document.createElement("input");
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'properties[Fudge ' + fudgeNumber + ']');
    document.querySelector(formClass).appendChild(input);
    findFudgeField = document.querySelector(formClass + ' ' + inputSelector);
  }
  findFudgeField.value = fudgeValue;

}